const _registeredSteppers = {};
export function getRegisteredSteppers() {
    return _registeredSteppers;
}
export function hasRegisteredStepper(name) {
    return _registeredSteppers.hasOwnProperty(name);
}
export function addRegisteredStepper(registeredStepper) {
    _registeredSteppers[registeredStepper.name] = registeredStepper;
}
//# sourceMappingURL=stepperDescriptions.js.map